import { Box, Button, Typography } from '@material-ui/core';
import { useDispatch, useSelector } from 'react-redux';
import { nutritionistSelector } from 'redux/selectors/nutritionist.selector';
import { setModalStatus } from 'redux/slices/modal.slice';
import {
  useRemoveNutritionistQuickBodyMapPermissionsService,
  useUpdateNutritionistPermissionsService,
} from 'hooks/nutritionists.hook';

export const ToggleQuickBodyMapModal = () => {
  const updatePermissionsService = useUpdateNutritionistPermissionsService();
  const removePermissionsService =
    useRemoveNutritionistQuickBodyMapPermissionsService();

  const nutritionist = useSelector(nutritionistSelector);

  const isQuickBodyMapEnabled =
    !!nutritionist?.permissions?.includes('quickBodyMap');

  const dispatch = useDispatch();

  const onConfirmHandler = () => {
    const payload = {
      nutritionistId: nutritionist.id,
      body: {
        permission: 'quickBodyMap',
      },
    };
    if (isQuickBodyMapEnabled) {
      removePermissionsService.mutate(payload);
    } else {
      updatePermissionsService.mutate(payload);
    }
  };

  const onCancelHandler = () => {
    dispatch(
      setModalStatus({
        name: 'TOGGLE_QUICK_BODY_MAP',
        isActive: false,
      }),
    );
  };

  return (
    <Box>
      <Typography variant="body2">
        ¿Estás seguro que deseas{' '}
        {isQuickBodyMapEnabled ? 'desactivar' : 'activar'} la el reporte Quick
        Body Map para este nutriólogo?
      </Typography>
      <Box
        display="flex"
        alignItems="center"
        justifyContent="space-around"
        mt={2}
      >
        <Button
          onClick={onConfirmHandler}
          color="primary"
          variant="contained"
          disabled={updatePermissionsService.isLoading}
        >
          Confirmar
        </Button>
        <Button onClick={onCancelHandler} color="primary" variant="outlined">
          Cancelar
        </Button>
      </Box>
    </Box>
  );
};
